export const DEFAULT_RATIO = 4 / 3;